import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {AuthGuardService, LoggedInGuardService} from '@innobile/authmodule';
import {PasswordResetComponent} from './password-reset/password-reset.component';

const routes: Routes = [{
  path: 'login',
  canActivate: [LoggedInGuardService],
  component: LoginComponent
}, {
  path: 'reset-password',
  component: PasswordResetComponent
}, {
  path: '',
  canLoad: [AuthGuardService],
  canActivate: [AuthGuardService],
  data: {breadcrumb: null},
  loadChildren: () => import('./main/main.module').then(m => m.MainModule)
}];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
